// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".none-data[data-v-6d9afcd3]{text-align:center;padding:40px}.none-data img[data-v-6d9afcd3]{width:300px;height:300px}.none-data p[data-v-6d9afcd3]{margin-top:20px;font-size:16px;line-height:22px;color:#a3a3a3}.none-data .self-img[data-v-6d9afcd3]{width:100%;height:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
